export default "__VITE_ASSET__Cad2yyuD__"